export default "__VITE_ASSET__ByJ4IIID__"